export const chunkSize = (size) => {
	let CHUNK_SIZE = 2 * 1024 * 1024;
	let CHUNK_DELAY = 500
	// if (size > 500 * 1024 * 1024 && size <= 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 3 * 1024 * 1024; // 大于500M的文件，设置为3MB一个分片
	// 	CHUNK_DELAY = 500
	// } else if (size > 1024 * 1024 * 1024 && size <= 5 * 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 6 * 1024 * 1024; // 大于1G的文件，设置为6MB一个分片
	// 	CHUNK_DELAY = 600
	// } else if (size > 5 * 1024 * 1024 * 1024 && size <= 10 * 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 10 * 1024 * 1024; // 大于5G的文件，设置为10MB一个分片
	// 	CHUNK_DELAY = 800
	// } else if (size > 10 * 1024 * 1024 * 1024 && size <= 20 * 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 20 * 1024 * 1024; // 大于10G的文件，设置为20MB一个分片
	// 	CHUNK_DELAY = 1200
	// } else if (size > 20 * 1024 * 1024 * 1024 && size <= 30 * 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 30 * 1024 * 1024; // 大于20G的文件，设置为30MB一个分片
	// 	CHUNK_DELAY = 1500
	// } else if (size > 30 * 1024 * 1024 * 1024) {
	// 	CHUNK_SIZE = 35 * 1024 * 1024; // 大于30G的文件，设置为35MB一个分片
	// 	CHUNK_DELAY = 2000
	// }
	if (size > 500 * 1024 * 1024 && size <= 1024 * 1024 * 1024) {
		CHUNK_SIZE = 3 * 1024 * 1024; // 大于500M的文件，设置为3MB一个分片
		CHUNK_DELAY = 500
	} else if (size > 1024 * 1024 * 1024 && size <= 5 * 1024 * 1024 * 1024) {
		CHUNK_SIZE = 5 * 1024 * 1024; // 大于1G的文件，设置为5MB一个分片
		CHUNK_DELAY = 600
	} else if (size > 5 * 1024 * 1024 * 1024 && size <= 10 * 1024 * 1024 * 1024) {
		CHUNK_SIZE = 8 * 1024 * 1024; // 大于5G的文件，设置为8MB一个分片
		CHUNK_DELAY = 800
	} else if (size > 10 * 1024 * 1024 * 1024 && size <= 20 * 1024 * 1024 * 1024) {
		CHUNK_SIZE = 10 * 1024 * 1024; // 大于10G的文件，设置为10MB一个分片
		CHUNK_DELAY = 1200
	} else if (size > 20 * 1024 * 1024 * 1024 && size <= 30 * 1024 * 1024 * 1024) {
		CHUNK_SIZE = 12 * 1024 * 1024; // 大于20G的文件，设置为12MB一个分片
		CHUNK_DELAY = 1500
	} else if (size > 30 * 1024 * 1024 * 1024) {
		CHUNK_SIZE = 15 * 1024 * 1024; // 大于30G的文件，设置为15MB一个分片
		CHUNK_DELAY = 2000
	}
	return {
		CHUNK_SIZE: CHUNK_SIZE,
		CHUNK_DELAY: CHUNK_DELAY
	};
}